// import { WarningTwoIcon } from "@chakra-ui/icons";
import {
  Button,
  Center,
  Icon,
  LightMode,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { IoWarning } from 'react-icons/io5';

const modalDesign: any = {
  position: 'absolute',
  top: '23%',
  bg: 'bg_box',
  color: 'color_main_text',
};

interface WarningModalProps {
  isOpen: boolean;
  color: string;
  dataHeader?: string;
  dataBody: string;
  btnAction: string;
  selectItem?: any;
  onClose: () => void;
  onAction?: (_selectItem: any) => void;
}

const WarningModal = ({
  isOpen,
  dataHeader,
  dataBody,
  color,
  btnAction,
  selectItem,
  onClose,
  onAction,
}: WarningModalProps) => {
  const { t } = useTranslation();
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay>
          <ModalContent {...modalDesign}>
            <ModalHeader fontSize='lg' fontWeight='bold'>
              {dataHeader}
            </ModalHeader>
            <Center>
              <Icon as={IoWarning} boxSize={20} color='orange' />
            </Center>
            <ModalBody fontSize={20} textAlign='center'>
              {dataBody}
            </ModalBody>
            <ModalCloseButton />
            <ModalFooter justifyContent='center' gap={3} mb={3}>
              <LightMode>
                <Button w='24' h='9' color='grey.900' onClick={onClose}>
                  {t('common.cancel')}
                </Button>
                <Button
                  w='24'
                  h='9'
                  colorScheme={color}
                  onClick={() => {
                    if (onAction) {
                      onAction(selectItem);
                    }
                    onClose();
                  }}
                >
                  {btnAction}
                </Button>
              </LightMode>
            </ModalFooter>
          </ModalContent>
        </ModalOverlay>
      </Modal>
    </>
  );
};

export default WarningModal;
